// Module
var code = "<react-component name=\"SequencePage\"></react-component>\n";
// Exports
module.exports = code;